<template>
	<div class="layers_sidebar tabs dash-tabs noscroll" :class="{'search_start' : search.length}">
		<div class="sidebar_header_box">
			<div class="sidebar_header_title">
				<h3>
                <span class="icon">
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M9.375 8.125H12.5C13.1904 8.125 13.75 8.68464 13.75 9.375V12.5C13.75 13.1904 13.1904 13.75 12.5 13.75H9.375C8.68464 13.75 8.125 13.1904 8.125 12.5V9.375C8.125 8.68464 8.68464 8.125 9.375 8.125ZM9.375 9.375V12.5H12.5V9.375H9.375ZM6.875 2.5V12.5C6.875 13.1904 6.31536 13.75 5.625 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H5.625C6.31536 1.25 6.875 1.80964 6.875 2.5ZM5.625 2.5H2.5V12.5H5.625V2.5ZM9.375 1.25H12.5C13.1904 1.25 13.75 1.80964 13.75 2.5V5.625C13.75 6.31536 13.1904 6.875 12.5 6.875H9.375C8.68464 6.875 8.125 6.31536 8.125 5.625V2.5C8.125 1.80964 8.68464 1.25 9.375 1.25ZM9.375 2.5V5.625H12.5V2.5H9.375Z"
                              fill="#97AACD"/>
                    </svg>
                </span>
					Layout
				</h3>
				<!--	        TODO -->
				<a @click="sidebarHideToggle" class="back_btn" style="visibility: hidden">
					<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd"
						      d="M3.07597 4.50007L6.16305 7.58716L4.83723 8.91298L0.424316 4.50007L4.83723 0.0871582L6.16305 1.41298L3.07597 4.50007ZM7.76347 4.50007L10.8506 7.58716L9.52473 8.91298L5.11182 4.50007L9.52473 0.0871582L10.8506 1.41298L7.76347 4.50007Z"
						      fill="#97AACD"/>
					</svg>
				</a>
			</div>
			<form class="top_form">
				<input type="text" placeholder="Search layers" v-model="search" @input="searchElements">
			</form>
		</div>
		<div id="tabs-content" class="noscroll">
			<div class="tab-content scroll-x scroll">
				<!-- SECTION -->
				<div class="" style="width: fit-content;min-width: 100%">
					<layout_section v-for="(section, index) in allSections" :key="section.id" @activateMe="activateMe"
					                :section="section" :section-id="section.id" :section-index="index"/>
				</div>
				<!-- SECTION END-->
				<div class="item_sidebar" v-if="!allSections.length"><p>No elements yet</p></div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import Layout_section from "@/modules/page-editor/src/components/sidebar/layout/layout_section";

export default {
	name: 'Layout',
	components: {Layout_section},
	data() {
		return {
			search: ''
		}
	},
	computed: {
		...mapGetters(['page_findAll', 'current_popup', 'page_findOne', 'page_findChild', 'page_id', 'page_tab']),
		view() {
			return this.$store.state.page.view
		},
		allSections(){
			return this.page_findAll(!!this.current_popup)
		}
	},
	methods: {
		sidebarHideToggle() {
			document.querySelector('.sidebar.sidebar_main').classList.toggle("sidebar_hiden");
		},
		activateMe(ev) {
			if(ev.block && this.page_id !== ev.block.id) {
				// let block = this.page_findChild(ev.block.id)
				this.$store.commit('PAGE_SET_TABID', {tab:this.page_tab, id:ev.block.id, block:ev.block})
			} else {
				console.log('same id');
			}

			setTimeout(() => {
				let element = document.querySelector('.main-center-content .current');

				element && element.scrollIntoView({
						behavior: 'smooth',
						block: 'center'
					});
				}, 200);
		},
		searchElements(ev) {
			var titles = document.querySelectorAll('.sidebar_layout_block .title');
			titles.forEach(title => {
				var titleText = title.innerText;
				var result = titleText.toLowerCase().includes(ev.target.value.toLowerCase());
				if (result && ev.target.value.length) {
					title.classList.add('search-match');
					if (title.classList.contains('child-title')) {
						title.parentElement.closest('.dash_item_sidebar').querySelector(".section-title").classList.add('search-match')
						title.parentElement.closest('.dash_item_sidebar').querySelector(".row-title").classList.add('search-match')
					}
					if (title.classList.contains('row-title')) {
						title.parentElement.closest('.dash_item_sidebar').querySelector(".section-title").classList.add('search-match')
					}
				} else {
					title.classList.remove('search-match');
				}
			});
		},
	},
}
</script>
<style lang="scss" scoped>
.layers_sidebar {
	display: flex;
	flex-direction: column;
}
</style>
<style lang="scss">
body .main .wrapper_main .sidebar .item_sidebar .wrapper_body .title.search-match {
	color: #15D7AE;
}

.dash-tabs {
	position: relative;
	z-index: 5;
	background-color: #fff;
}

.dash-tabs .title span {
	white-space: nowrap;
	text-overflow: ellipsis;
	margin: 0 !important;
	cursor: pointer;
}

.title.column-title {
	pointer-events: none;
}

.main .wrapper_main .sidebar .item_sidebar .section-title {
	cursor: pointer;
	padding: 9px 15px;
	position: sticky;
	top: 0;
	z-index: 10;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-right: 25px;
	padding-left: 20px;
	font-weight: 500;
	font-size: 13px;
	line-height: 150%;
	letter-spacing: 0.02em;
	color: #252A32;
	border-top: 1px solid #EBEFF6;
}

.main .wrapper_main .sidebar .dash_item_sidebar {
	padding: 0;
	overflow: hidden;
	max-height: 42px;
	transition: all 0.3s ease;

}

.main .wrapper_main .sidebar .dash_item_sidebar.active {
	max-height: 1000px;
	overflow: auto;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title > span {
	position: relative;
	display: flex;
	align-items: center;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title > span:before,
.layout_section_title:before {
	content: '';
	display: block;
	border: 4px solid transparent;
	border-left: 6px solid #C5C7D2;
	margin-left: -5px;
	pointer-events: none;
	transition: 0.15s all ease-in-out;
	transform-origin: 3px;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title.active > span:before,
.dash_item_sidebar.active .layout_section_title:before {
	transform: rotate(90deg);
}

.main .wrapper_main .sidebar .dash_item_sidebar.active .title.section-title {
	background: #4368E0;
	color: #fff;
}

.layout_section_title {
	display: flex;
	align-items: center;
	position: relative;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title {
	margin: 0;
	padding: 10px 15px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-weight: 500;
	font-size: 13px;
	line-height: 150%;
	letter-spacing: 0.02em;
	color: #252A32;
	background: #fff;
	border-top: 1px solid #EBEFF6;
	position: relative;
	padding-left: 34px;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title.active {
	background: #F6F9FE;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .title.column-title {
	width: 100%;
	padding: 11px 46px;
	cursor: pointer;
	font-weight: 500;
	font-size: 13px;
	line-height: 150%;
	letter-spacing: 0.02em;
	color: #252A32;
}

.item.dash-item {
	background: #fff;
}

.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body.wrapper_body_block + .wrapper_body_block {
	padding-top: 0;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .field .wrapper_input.dash-buttons,
.title .dash-buttons {
	opacity: 0;
	pointer-events: none;
	transition: all 0.3s ease;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .field:hover .wrapper_input.dash-buttons,
.title:hover .dash-buttons,
.title.current .dash-buttons,
.main .wrapper_main .sidebar .item_sidebar .wrapper_body .field .current + .dash-buttons {
	opacity: 1;
	pointer-events: all;
}

/* .dash-buttons .right_top_controls_btn.delete_btn {
    background-color: #FF7A82;
} */
.right_top_controls_btn.delete_btn:hover {
	background-color: #D04850;
}

.child-title {
	cursor: pointer;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .title.child-title .icon,
.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title .icon,
.item_sidebar .layout_section_title .icon {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0 10px !important;
	margin-left: 7px !important;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .title.child-title .icon svg,
.main .wrapper_main .sidebar .dash_item_sidebar .wrapper_body .row-title .icon svg,
.item_sidebar .layout_section_title .icon svg {
	max-width: 15px;
	max-height: 15px;
}

.main .wrapper_main .sidebar .dash_item_sidebar.active .layout_section_title .icon svg path {
	fill: #fff;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .title.child-title {
	font-weight: 500;
	font-size: 13px;
	line-height: 150%;
	display: flex;
	align-items: center;
	letter-spacing: 0.02em;
	color: #252A32;
	padding: 10px 15px;
	padding-left: 30px;
	width: 100%;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .child-title-wrpr.current {
	background: #EEF4FF;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .child-title-wrpr.current .title.child-title {
	color: #4368E0;
}

.main .wrapper_main .sidebar .item_sidebar .wrapper_body .child-title-wrpr.current .title.child-title .icon svg path {
	fill: #4368E0;
}

.main .wrapper_main .sidebar .item_sidebar.sidebar_layout_block .wrapper_body .dash-item .field {
	border-bottom: 0;
}
</style>
